export const placeholderImage = "https://i.iheart.com/v3/re/new_assets/f79fc341-a979-4863-81b0-eea1ddc6e07b";

export function getMediaServerUrl(host: string, bucket: string, id: string) {
  return `https://${host}/v3/re/${bucket}${id}`;
}
